<template>
    <svg
        fill="none"
        :style="sizeStyle"
        viewBox="0 0 18.25 19.3"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <clipPath :id="clipId">
                <circle
                    cx="9.215"
                    cy="10.302"
                    r="8"
                />
            </clipPath>
        </defs>
        <circle
            class="fill-v-dark-800 stroke-v-dark-800"
            cx="9.215"
            cy="10.302"
            r="8.5"
        />
        <path
            :clip-path="`url(#${clipId})`"
            class="fill-white"
            d="M10.451 7.427 8.133 11.958l1.761 3.444-.989 1.087C7.861 14.45 6.124 11.052 6.124 11.052L2.416
               18.302h13.597L10.451 7.427Z"
        />
        <path
            class="fill-white stroke-v-dark-800"
            d="M4.62109 0.510742C4.71115 0.525485 4.79814 0.555171 4.87891 0.597656L4.99512 0.670898
               L5.09766 0.762695C5.16057 0.828609 5.21309 0.903913 5.25195 0.986328L5.2998 1.11523L5.67773 2.4375
               C5.73568 2.6404 5.84401 2.82536 5.99316 2.97461C6.14237 3.12381 6.32741 3.233 6.53027 3.29102
               H6.53125L7.85254 3.66895H7.85352C7.98631 3.70704 8.10719 3.77655 8.20605 3.87109L8.29688 3.97363
               L8.37109 4.08984C8.43463 4.21088 8.46777 4.34632 8.46777 4.48438
               C8.46776 4.66862 8.40777 4.84799 8.29688 4.99512C8.18602 5.14208 8.03047 5.24906 7.85352 5.2998
               H7.85254L6.53125 5.67773H6.53027C6.32742 5.73575 6.14236 5.84495 5.99316 5.99414
               C5.84405 6.14338 5.73567 6.32839 5.67773 6.53125L5.2998 7.85352
               C5.24906 8.03064 5.14225 8.18694 4.99512 8.29785C4.84806 8.4087 4.66853 8.46868 4.48438 8.46875
               C4.30026 8.46875 4.12071 8.40858 3.97363 8.29785C3.86336 8.21474 3.77521 8.10604 3.7168 7.98242
               L3.66797 7.85352L3.29102 6.53125C3.23306 6.32832 3.1238 6.1434 2.97461 5.99414
               C2.82535 5.84488 2.64046 5.73573 2.4375 5.67773L1.11523 5.2998
               C0.938121 5.24907 0.78181 5.14222 0.670898 4.99512
               C0.587692 4.88473 0.532804 4.75618 0.510742 4.62109L0.5 4.48438L0.510742 4.34766
               C0.532786 4.21252 0.587668 4.08406 0.670898 3.97363L0.761719 3.87109
               C0.860686 3.7764 0.982257 3.70704 1.11523 3.66895L2.4375 3.29102
               C2.64048 3.23302 2.82534 3.12388 2.97461 2.97461C3.12384 2.82533 3.23305 2.64047 3.29102 2.4375
               L3.66797 1.11523C3.71859 0.938062 3.82559 0.781913 3.97266 0.670898L4.08887 0.597656
               C4.21008 0.533846 4.34604 0.500029 4.48438 0.5L4.62109 0.510742Z"
        />
    </svg>
</template>

<script>
    export default {
        name: 'v-icon-hamilton',
        props: {
            size: {
                default: '1em',
                type: [Number, String],
            },
        },
        computed: {
            clipId() {
                return `v-icon-hamilton-${this.$.uid}`;
            },
            sizeStyle() {
                const value = typeof this.size === 'number' ? `${this.size}px` : this.size;
                return { width: value, height: value };
            },
        },
    };
</script>
